// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"417197fe","312":"e3e2f4bf","457":"56d16f78","461":"d6bdb749","488":"5c27b6b9","551":"cbd18dcc","672":"a486cac2","828":"40397b2d","842":"f1776bf3","851":"b51f9b75"}[chunkId] + ".chunk.js";
};